export const pricingTiers = [
  {
    id: 'premium',
    name: 'Premium',
    featured: true,
    sale: { percent: 50, endsIn: '29:59' },
    price: { current: 19.99, original: 32 },
    // first-week price; the pricing page shows it with the regular weekly price crossed out
    intro: { price: 3 },
    features: { photos: 200, videos: 30, noWatermark: true }
  },
  {
    id: 'starter',
    name: 'Starter',
    featured: false,
    price: { current: 9.99 },
    features: { photos: 50, videos: 10, noWatermark: true }
  },
  {
    id: 'coming-soon',
    name: 'Coming soon',
    comingSoon: true,
    upcomingFeatures: [
      { icon: 'video-sound.svg', text: 'Video with sound' },
      { icon: 'qwen.svg', text: 'NSFW Qwen' },
      { icon: 'banana.svg', text: 'Nano Banana striptease' }
    ]
  }
];
